import useUserInfo from 'hooks/react-query/use-user-info';
import { ComponentsIdType } from 'hooks/react-query/use-user-info/use-user-info.types';
import { GetIsDisplayComponentOptionsType } from './use-component.props';
import { PAGES } from 'common/enums';


export const useComponent = () => {
  const { userInfo } = useUserInfo();

  const getIsDisplayComponent= (
    ids: ComponentsIdType[] | ComponentsIdType,
    { showByDefault = true , idsDefaultApperance}: GetIsDisplayComponentOptionsType = {}
  ) => {
    if (userInfo?.appPages.components === null || !userInfo?.appPages?.components?.length) {
      if(Array.isArray(ids) && idsDefaultApperance){
        return [...Object.entries(idsDefaultApperance).map(([_ , value]) => value)];
      }
      if(Array.isArray(ids) && !idsDefaultApperance){
         return [...ids.map( id => false)];
      }
      return showByDefault;
    }
    if(!Array.isArray(ids)){
      return userInfo?.appPages.components?.some(item => item.attributes.uds_name === ids);
    }
    
    return ids.reduce((prevValue:Array<boolean>, currValue:string, index:number)=>{
      prevValue.push(userInfo?.appPages.components?.some(item => item.attributes.uds_name === ids[index]));
      return prevValue;
    },[] as Array<boolean>);
  };

  const getIsPageAvailable = (page: PAGES) => {
    return userInfo?.appPages?.pages?.some(pageItem => pageItem.url === page) || false;
  };

  return { getIsDisplayComponent, getIsPageAvailable };
};
